import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../Context/Context";
import { createAddress } from "../Services/ContectService";
import { toast } from "react-toastify";

const CreateAddress = () => {
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [physical_address, setPhysical_address] = useState("");
  const [postal_code, setPostal_code] = useState("");
  const [reciever_name, setReciever_name] = useState("");
  const [phone_number, setPhone_number] = useState("");

  const { json, user, provinceList } = useContext(Context);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !province.trim() ||
      !city.trim() ||
      !physical_address.trim() ||
      !postal_code.trim()
    ) {
      return toast.error("لطفاً تمام فیلدهای لازم را پر کنید");
    }
    const information = {
      province,
      city,
      physical_address,
      postal_code,
      reciever_name,
      phone_number,
    };
    try {
      const { status, data } = await createAddress(information, user);
      if (status === 201) {
        navigate("/account/addresses");
      }
    } catch (ex) {
      toast.error(json.toast.err_1);
    }
  };
  return (
    <>
      <div className="lg:w-[65%] w-full rounded-xl flex bg-gray-100 border border-black">
        <form onSubmit={handleSubmit} className="account-form flex-wrap">
          <div className="lg:w-5/12 mt-3 lg:mt-0 w-full flex flex-col">
            <label htmlFor="name" className=" mb-2 font-bold text-gray-900">
              <span className="asterisk">*</span>
              استان :
            </label>
            {/* <input name="province" value={province} onChange={e => setProvince(e.target.value)} type="text" id="province" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" /> */}
            <select
              value={province}
              onChange={(ev) => setProvince(ev.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            >
              <option value="" className="hidden">
                استان را انتخاب کنید
              </option>
              {provinceList.map((item, index) => (
                <option key={`province_${index}`} value={item.state}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="lg:w-5/12 w-full mt-3 lg:mt-0 flex flex-col">
            <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">
              <span className="asterisk">*</span>شهر :
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
          </div>
          <div className="w-full mt-3">
            <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">
              <span className="asterisk">*</span>آدرس :
            </label>
            <textarea
              cols="50"
              id="physical_address"
              name="physical_address"
              value={physical_address}
              onChange={(e) => setPhysical_address(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
          </div>
          <div className="w-full mt-3 flex items-center justify-between flex-wrap gap-2">
            <div className="lg:w-3/12 w-full mt-3 lg:mt-0 flex flex-col">
              <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">
                <span className="asterisk">*</span>کد پستی:
              </label>
              <input
                type="number"
                id="postal_code"
                name="postal_code"
                value={postal_code}
                onChange={(e) => setPostal_code(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              />
            </div>
            <div className="lg:w-3/12 w-full mt-3 lg:mt-0 flex flex-col">
              <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">
                نام گیرنده:
              </label>
              <input
                type="text"
                id="reciever_name"
                name="reciever_name"
                value={reciever_name}
                onChange={(e) => setReciever_name(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              />
            </div>
            <div className="lg:w-3/12 w-full mt-3 lg:mt-0 flex flex-col">
              <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">
                شماره تماس:
              </label>
              <input
                type="number"
                id="phone_number"
                name="phone_number"
                value={phone_number}
                onChange={(e) => setPhone_number(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              />
            </div>
          </div>
          <div className="w-full mt-3 mb-4 flex-row-reverse flex">
            <Link
              to="/account/addresses"
              className="bg-blue-700 justify-center items-center w-40 p-2 rounded-lg flex cursor-pointer"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 26 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.5012 11C25.5012 11.3978 25.3431 11.7794 25.0618 12.0607C24.7805 12.342 24.399 12.5 24.0012 12.5H5.62618L12.0662 18.9388C12.348 19.2206 12.5063 19.6027 12.5063 20.0013C12.5063 20.3998 12.348 20.782 12.0662 21.0638C11.7844 21.3456 11.4022 21.5039 11.0037 21.5039C10.6052 21.5039 10.223 21.3456 9.94118 21.0638L0.941183 12.0638C0.801343 11.9244 0.690387 11.7588 0.614679 11.5765C0.538971 11.3942 0.5 11.1987 0.5 11.0013C0.5 10.8038 0.538971 10.6084 0.614679 10.426C0.690387 10.2437 0.801343 10.0781 0.941183 9.93876L9.94118 0.938759C10.0807 0.799229 10.2464 0.688548 10.4287 0.613036C10.611 0.537523 10.8064 0.498657 11.0037 0.498657C11.201 0.498657 11.3964 0.537523 11.5787 0.613036C11.761 0.688548 11.9267 0.799229 12.0662 0.938759C12.2057 1.07829 12.3164 1.24393 12.3919 1.42624C12.4674 1.60854 12.5063 1.80393 12.5063 2.00126C12.5063 2.19858 12.4674 2.39398 12.3919 2.57628C12.3164 2.75858 12.2057 2.92423 12.0662 3.06376L5.62618 9.50001H24.0012C24.399 9.50001 24.7805 9.65804 25.0618 9.93935C25.3431 10.2207 25.5012 10.6022 25.5012 11Z"
                  fill="white"
                />
              </svg>
              <p className="text-white mr-3">بازگشت</p>
            </Link>
            <button
              type="submit"
              className="ml-4 bg-blue-700 justify-center items-center w-40 p-2 rounded-lg flex cursor-pointer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.2395 3.06126L9.69263 19.0613C9.55722 19.2011 9.39632 19.3121 9.21916 19.3878C9.042 19.4635 8.85205 19.5024 8.66022 19.5024C8.4684 19.5024 8.27845 19.4635 8.10129 19.3878C7.92413 19.3121 7.76323 19.2011 7.62782 19.0613L0.826075 12.0613C0.690497 11.9217 0.582951 11.7561 0.509577 11.5738C0.436203 11.3915 0.398438 11.1961 0.398438 10.9988C0.398437 10.8014 0.436203 10.606 0.509577 10.4237C0.582951 10.2414 0.690497 10.0758 0.826075 9.93626C0.961652 9.79673 1.12261 9.68605 1.29975 9.61054C1.47689 9.53502 1.66675 9.49616 1.85848 9.49616C2.05022 9.49616 2.24008 9.53502 2.41722 9.61054C2.59436 9.68605 2.75531 9.79673 2.89089 9.93626L8.66144 15.875L23.1771 0.938759C23.4509 0.656966 23.8223 0.498657 24.2095 0.498657C24.5967 0.498657 24.9681 0.656966 25.2419 0.938759C25.5157 1.22055 25.6695 1.60274 25.6695 2.00126C25.6695 2.39977 25.5157 2.78197 25.2419 3.06376L25.2395 3.06126Z"
                  fill="white"
                />
              </svg>
              <p className="text-white mr-3">ذخیره اطلاعات</p>
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateAddress;
